import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading } from '@/decorators';

var LogModal = function (_super) {
  __extends(LogModal, _super);

  function LogModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.loadingStatus = false;
    _this.tableData = [];
    _this.total = 0;
    _this.searchData = _this.initSearchData();
    return _this;
  }

  LogModal.prototype.initSearchData = function () {
    return {
      relation_id: '',
      page_index: 1,
      page_size: 20
    };
  };

  Object.defineProperty(LogModal.prototype, "columns", {
    get: function get() {
      return [{
        title: this.t('操作类型'),
        dataIndex: 'operate_type_text',
        filterEmpty: true,
        width: 120
      }, {
        title: this.t('操作前'),
        dataIndex: 'operate_before',
        filterEmpty: true
      }, {
        title: this.t('操作后'),
        dataIndex: 'operate_after',
        filterEmpty: true
      }, {
        title: this.t('操作人'),
        dataIndex: 'create_user_name',
        filterEmpty: true,
        width: 120
      }, {
        title: this.t('IP'),
        dataIndex: 'ip',
        filterEmpty: true,
        width: 150
      }, {
        title: this.t('时间'),
        dataIndex: 'create_time',
        filterEmpty: true,
        width: 180
      }];
    },
    enumerable: false,
    configurable: true
  });

  LogModal.prototype.open = function (record) {
    this.tableData = [];
    this.visible = true;
    this.searchData = this.initSearchData();
    this.searchData.relation_id = record.id;
    this.queryLogList();
  };

  LogModal.prototype.handlePageChange = function (pageIndex, pageSize) {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.queryLogList();
  };

  LogModal.prototype.queryLogList = function () {
    var _a, _b;

    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.batchAttribute.queryBatchRuleLogList(this.searchData)];

          case 1:
            res = _c.sent();
            this.tableData = ((_a = res.data) === null || _a === void 0 ? void 0 : _a.list) || [];
            this.total = +((_b = res.data) === null || _b === void 0 ? void 0 : _b.total) || 0;
            return [2];
        }
      });
    });
  };

  __decorate([loading('loadingStatus')], LogModal.prototype, "queryLogList", null);

  LogModal = __decorate([Component], LogModal);
  return LogModal;
}(Vue);

export default LogModal;